__webpack_require__.p = "/wysiwyg-toolbar-active-fix/referrals/";